import {createRouter, createWebHistory} from "vue-router";

import HomeView from '@/Components/HomeView.vue';
import AccountManager from '@/Pages/Dashboards/AccountManager.vue';
import MessagingDashboard from '@/Pages/Dashboards/MessagingDashboard.vue';
import AdjusterDashboard from "@/Pages/Dashboards/AdjusterDashboard.vue";
import AdminDashboard from "@/Pages/Dashboards/AdminDashboard.vue";
import BatchDashboard from "@/Pages/Dashboards/BatchDashboard.vue";
import BulkAssignClaims from "@/Pages/Dashboards/BulkAssignClaims.vue";
import ChartsDashboard from "@/Pages/Dashboards/ChartsDashboard.vue";
import ClaimsDashboard from "@/Pages/Dashboards/ClaimsDashboard.vue";
import ClientDashboard from "@/Pages/Dashboards/ClientDashboard.vue";
import MyProfileDashboard from "@/Pages/Dashboards/MyProfileDashboard.vue";
import MarketingDashboard from "@/Pages/Dashboards/MarketingDashboard.vue";
import PayDetailsDashboard from "@/Pages/Dashboards/PayDetailsDashboard.vue";
import PaymentsDashboard from "@/Pages/Dashboards/PaymentsDashboard.vue";
import ReportsDashboard from "@/Pages/Dashboards/ReportsDashboard.vue";
import SearchClaimsDashboard from "@/Pages/Dashboards/SearchClaimsDashboard.vue";
import SearchUsersDashboard from "@/Pages/Dashboards/SearchUsersDashboard.vue";
import UserDashboard from "@/Pages/Dashboards/UserDashboard.vue";
import BatchView from "@/Pages/Views/BatchView.vue";
import ClaimView from "@/Pages/Views/ClaimView.vue";
import ClientView from "@/Pages/Views/ClientView.vue";
import UserProfileView from "@/Pages/Views/UserProfileView.vue";
import MyPayperiodView from "@/Pages/Views/MyPayperiodView.vue";
import PayPeriodDetailsView from "@/Pages/Views/PayPeriodDetailsView.vue";
import PayPeriodPersonDetailsView from "@/Pages/Views/PayPeriodPersonDetailsView.vue";
import PersonFormComponent from "@/Components/PersonForm/PersonFormComponent.vue";
import WorkflowEditorComponent from "@/Components/Tasks/WorkflowEditorComponent.vue";
import ReportClientClaimsComponent from "@/Components/ReportClientClaims/ReportClientClaimsComponent.vue";
import ReportClientRevenueComponent from "@/Components/ReportClientRevenue/ReportClientRevenueComponent.vue";
import MarketingMyListComponent from "@/Components/Marketing/MarketingMyListComponent.vue";
import ClaimscoFinancialView from "@/Pages/Views/ClaimscoFinancialView.vue";
import CollectionsReportView from "@/Pages/Views/CollectionsReportView.vue";
import ReviewerDashboard from "@/Pages/Dashboards/ReviewerDashboard.vue";
import UnassignedClaimsMapComponent from "@/Components/Claims/UnassignedClaimsMapComponent.vue";
import UnauthorizedView from "@/Pages/Views/UnauthorizedView.vue";
import BulkAssignSpecificClaimView from "@/Pages/Views/BulkAssignSpecificClaimView.vue";
import ChangePasswordComponent from "@/Components/UserManagement/ChangePasswordComponent.vue";
import ManageRolesDashboard from "@/Pages/Dashboards/ManageRolesDashboard.vue";
import ReleaseHoldbacksView from "@/Pages/Views/ReleaseHoldbacksView.vue";
import GenerateNewHoldbacksView from "@/Pages/Views/GenerateNewHoldbacksView.vue";
import ReturnedForCorrectionsDashboard from "@/Pages/Dashboards/ReturnedForCorrectionsDashboard.vue";
import ClientPortalDashboard from "@/Pages/Dashboards/ClientPortalDashboard.vue";
import EmailImportClaimsView from "@/Pages/Views/EmailImportClaimsView.vue";

import {userStore} from "@/Stores/UserStore";
import {Permissions} from "@/Utils/Permissions";
import {getCurrentUser} from 'aws-amplify/auth';
import ClientClaimView from "@/Pages/Views/ClientClaimView.vue";
import AgingReceivablesDashboard from "@/Components/Reports/AgingReceivablesDashboard.vue";
import InvoiceSearchView from "@/Pages/Views/InvoiceSearchView.vue";
import EmailImportView from "@/Pages/Views/EmailImportView.vue";



const routes = [
    {
        path: '/',
        component: HomeView,
        meta: {
            requiresAuth: true,
            permissions: []
        }
    },
    {
        path: '/dashboards/change-password',
        component: ChangePasswordComponent,
        meta: {
            requiresAuth: true,
            permissions: []
        }
    },
    {
        path: '/dashboards/account-manager',
        component: AccountManager,
        meta: {
            requiresAuth: true,
            permissions: ["dashboards.account-manager"]
        }
    },
    {
        path: '/dashboards/messaging',
        component: MessagingDashboard,
        meta: {
            requiresAuth: true,
            permissions: ["dashboards.messaging"]
        },
        children: [
            {
                path: ':conversationId',
                component: MessagingDashboard
            }
        ]
    },
    {
        path: '/dashboards/adjuster',
        component: AdjusterDashboard,
        meta: {
            requiresAuth: true,
            permissions: ["dashboards.adjuster"]
        }
    },
    {
        path: '/dashboards/admin',
        component: AdminDashboard,
        meta: {
            requiresAuth: true,
            permissions: ["dashboards.admin"]
        }
    },
    {
        path: '/dashboards/aging-receivables',
        component: AgingReceivablesDashboard,
        meta: {
            requiresAuth: true,
            permissions: ["dashboards.aging-receivables"]
        }
    },
    {
        path: '/dashboards/batches',
        component: BatchDashboard,
        meta: {
            requiresAuth: true,
            permissions: ["dashboards.batches"]
        }
    },
    {
        path: '/dashboards/bulk-assign-claims',
        component: BulkAssignClaims,
        meta: {
            requiresAuth: true,
            permissions: ["dashboards.bulk-assign-claims"]
        }
    },
    {
        path: '/dashboards/charts',
        component: ChartsDashboard,
        meta: {
            requiresAuth: true,
            permissions: ["dashboards.charts"]
        }
    },
    {
        path: '/dashboards/claims',
        component: ClaimsDashboard,
        meta: {
            requiresAuth: true,
            permissions: ["dashboards.claims"]
        }
    },
    {
        path: '/dashboards/clients',
        component: ClientDashboard,
        meta: {
            requiresAuth: true,
            permissions: ["dashboards.clients"]
        }
    },
    {
        path: '/dashboards/client-portal',
        component: ClientPortalDashboard,
        meta: {
            requiresAuth: true,
            permissions: ["dashboards.client-portal"]
        }
    },
    {
        path: '/dashboards/my-profile',
        component: MyProfileDashboard,
        meta: {
            requiresAuth: true,
            permissions: []
        }
    },
    {
        path: '/dashboards/marketing',
        component: MarketingDashboard,
        meta: {
            requiresAuth: true,
            permissions: ["dashboards.marketing"]
        }
    },
    {
        path: '/dashboards/pay-details',
        component: PayDetailsDashboard,
        meta: {
            requiresAuth: true,
            permissions: ["dashboards.pay-details"]
        }
    },
    {
        path: '/dashboards/payments',
        component: PaymentsDashboard,
        meta: {
            requiresAuth: true,
            permissions: ["dashboards.payments"]
        }
    },
    {
        path: '/dashboards/reports',
        component: ReportsDashboard,
        meta: {
            requiresAuth: true,
            permissions: ["dashboards.reports"]
        }
    },
    {
        path: '/dashboards/returnedforcorrections',
        component: ReturnedForCorrectionsDashboard,
        meta: {
            requiresAuth: true,
            permissions: ["dashboards.returned-for-corrections"]
        }
    },
    {
        path: '/dashboards/reviewer',
        component: ReviewerDashboard,
        meta: {
            requiresAuth: true,
            permissions: ["dashboards.reviewer"]
        }
    },
    {
        path: '/dashboards/search-claims',
        component: SearchClaimsDashboard,
        meta: {
            requiresAuth: true,
            permissions: ["claims.search"]
        }
    },
    {
        path: '/dashboards/search-users',
        component: SearchUsersDashboard,
        meta: {
            requiresAuth: true,
            permissions: ["users.search"]
        }
    },
    {
        path: '/dashboards/users',
        component: UserDashboard,
        meta: {
            requiresAuth: true,
            permissions: ["dashboards.users"]
        }
    },
    {
        path: '/dashboards/manage-roles',
        component: ManageRolesDashboard,
        meta: {
            requiresAuth: true,
            permissions: [],
            adminOnly: true
        }
    },
    {
        path: '/batch/:id',
        component: BatchView,
        meta: {
            requiresAuth: true,
            permissions: ["payments.read-batch"]
        }
    },
    {
        path: '/bulkassignspecificclaim/:id',
        component: BulkAssignSpecificClaimView,
        meta: {
            requiresAuth: true,
            permissions: ["claims.bulk-assign"]
        }
    },
    {
        path: '/claim/:claimId',
        component: ClaimView,
        meta: {
            requiresAuth: true,
            permissions: ["claims.read"]
        }
    },
    {
        path: '/clientclaim/:claimId',
        component: ClientClaimView,
        meta: {
            requiresAuth: true,
            permissions: ["client-portal.read"]
        }
    },
    {
        path: '/client/:clientId',
        component: ClientView,
        meta: {
            requiresAuth: true,
            permissions: ["clients.read"]
        }
    },
    {
        path: '/userprofile/:userProfileId',
        component: UserProfileView,
        meta: {
            requiresAuth: true,
            permissions: ["users.read"]
        }
    },
    {
        path: '/payperiod/:payperiodId',
        component: PayPeriodDetailsView,
        meta: {
            requiresAuth: true,
            permissions: ["pay-periods.list"]
        }
    },
    {
        path: '/payperiod/:payperiodId/person/:personId',
        component: PayPeriodPersonDetailsView,
        meta: {
            requiresAuth: true,
            permissions: ["pay-periods.list"]
        }
    },
    {
        path: '/mypayperiod/:id',
        component: MyPayperiodView,
        meta: {
            requiresAuth: true,
            permissions: ["my-pay-period.pay-period"]
        }
    },
    {
        path: '/personform',
        component: PersonFormComponent,
        meta: {
            requiresAuth: true,
            permissions: ["users.create"]
        }
    },
    {
        path: '/workfloweditor',
        component: WorkflowEditorComponent,
        meta: {
            requiresAuth: true,
            permissions: ["tasks.list-workflows"]
        }
    },
    {
        path: '/reportclientclaims',
        component: ReportClientClaimsComponent,
        meta: {
            requiresAuth: true,
            permissions: ["reports.claims"]
        }
    },
    {
        path: '/reportclientrevenue',
        component: ReportClientRevenueComponent,
        meta: {
            requiresAuth: true,
            permissions: ["reports.revenue"]
        }
    },
    {
        path: '/mymarketingpay',
        component: MarketingMyListComponent,
        meta: {
            requiresAuth: true,
            permissions: ["marketing.list"]
        }
    },
    {
        path: '/claimsco/financials',
        component: ClaimscoFinancialView,
        meta: {
            requiresAuth: true,
            permissions: ["dashboards.financial"]
        }
    },
    {
        path: '/collectionsreport',
        component: CollectionsReportView,
        meta: {
            requiresAuth: true,
            permissions: ["invoices.read-collection"]
        }
    },
    {
        path: '/unassignedclaimsmap',
        component: UnassignedClaimsMapComponent,
        meta: {
            requiresAuth: true,
            permissions: ["claims.unassigned"]
        }
    },
    {
        path: '/releaseholdbacks/:payPeriodId',
        component: ReleaseHoldbacksView,
        meta: {
            requiresAuth: true,
            permissions: ["holdbacks.release"]
        }
    },
    {
        path: '/generatenewholdbacks/:payPeriodId',
        component: GenerateNewHoldbacksView,
        meta: {
            requiresAuth: true,
            permissions: ["holdbacks.generate-new"]
        }
    },
    {
        path: '/invoicesearch',
        component: InvoiceSearchView,
        meta: {
            requiresAuth: true,
            permissions: ["invoices.list"]
        }
    },
    {
        path: '/emailimportclaims',
        component: EmailImportClaimsView,
        meta: {
            requiresAuth: true,
            permissions: ["claims.create"]
        }
    },
    {
        path: '/emailimport/:id',
        component: EmailImportView,
        meta: {
            requiresAuth: true,
            permissions: ["claims.create"]
        }
    },

    {
        path: '/unauthorized',
        component: UnauthorizedView,
        meta: {
            requiresAuth: true,
            permissions: []
        }
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes
});

//This is purely for reading client's cookie to determine if they've already handled the Texting Enabled pop-up event
//for their current active session. This is only applicable when a user authenticates while have texting disabled and in
//that session they enabled or set reminder that session. It's meant only to handle reloading the page only.
//The writing of this value is handled in UserProfileComponent.vue  ...we need a cookie helper class/service.
//TODO move the value of 'key' to better scope, so it can be shared app-wide (or better yet, write cookie-helper class)
const GetClientTextReminderCookieVal = () => {
    const key = "clientReminders_textingEnabled";     //Value of 0 means not handled, 1 == enabled, 2 == reminder
    const match = document.cookie.match(new RegExp('(?:^|; )' + key + '=([^;]*)'));
    return match ? parseInt(decodeURIComponent(match[1]), 10) : 0;
};

const CheckClientTextingReminder = async () => {
    let cookieVal = GetClientTextReminderCookieVal();
    let usVal = userStore.textMessagingEnableReminder && userStore.textMessagingEnableReminder === true;
    return ( usVal === true && cookieVal < 1 );
};

router.beforeEach(async (to, from, next) => {
    if(to.meta && to.meta.requiresAuth) {
        const user = await getCurrentUser();
        if (to.meta.permissions && !Permissions.checkPermissions(to.meta.permissions,to.meta.adminOnly || false)) {
            next(`/unauthorized`);
        } else {
            next();
        }
    }
    else {
        next();
    }
});

//Handler for users logging in that have not opted into text messaging yet
router.beforeEach( async( to, from, next ) => {
    if(to.meta && to.meta.requiresAuth) {
        let showReminder = await CheckClientTextingReminder();
        if(to.path !== '/dashboards/my-profile' && showReminder) {
            next('/dashboards/my-profile');
        } else {
            next();
        }
    } else {
        next();
    }
});

export default router;